import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

import { concatBuffers } from './utils/byteUtils';
import { noop } from './utils/functionUtils';
/**
 * Read bytes from a ReadableStream until the end of the stream.
 * Returns the bytes if collectStreamBody is true, otherwise returns undefined.
 */

export function readBytesFromStream(_x, _x2) {
  return _readBytesFromStream.apply(this, arguments);
}

function _readBytesFromStream() {
  _readBytesFromStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream, options) {
    var reader, chunks, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reader = stream.getReader();
            chunks = [];

          case 2:
            if (!true) {
              _context.next = 11;
              break;
            }

            _context.next = 5;
            return reader.read();

          case 5:
            result = _context.sent;

            if (!result.done) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("break", 11);

          case 8:
            if (options.collectStreamBody) {
              chunks.push(result.value);
            }

            _context.next = 2;
            break;

          case 11:
            reader.cancel()["catch"]( // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
            // as an unhandled rejection
            noop);
            return _context.abrupt("return", options.collectStreamBody ? concatBuffers(chunks) : undefined);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _readBytesFromStream.apply(this, arguments);
}